import React, { type FC, type ElementType } from 'react';

import { AuthRequired } from '@components';
import { useStore } from '../../store/useStore';

interface IPrivateContentProps {
  title?: string;
  component: ElementType;
  replaceComponent?: ElementType;
}

const PrivateContent: FC<IPrivateContentProps> = ({
  component: Component,
  replaceComponent: ReplaceComponent,
  title,
}) => {
  const { isAuthenticated } = useStore();

  return (
    <>
      {!isAuthenticated ? (
        ReplaceComponent ? (
          <ReplaceComponent />
        ) : (
          <AuthRequired title={title} />
        )
      ) : (
        <Component />
      )}
    </>
  );
};

export default PrivateContent;
